var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "#266BEE",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.125 0.194946H5.875C2.92 0.194946 0.5 2.64928 0.5 5.6462V38.3537C0.5 41.3506 2.92 43.8049 5.875 43.8049H22.185V28.1662H17.035V21.3559H22.185V17.9432C22.185 12.6846 26.015 8.56198 30.905 8.56198H35.65V16.2546H31.405C30.295 16.2546 29.965 16.9037 29.965 17.7961V21.3559H35.65V28.1662H29.97V43.8049H38.125C41.08 43.8049 43.5 41.3506 43.5 38.3537V5.6462C43.5 2.64928 41.08 0.194946 38.125 0.194946Z"
  })));
};
export default SvgFacebook;